import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'dpl/common/components/Icon';
import Drawer, {
  DrawerItem,
  DrawerItemTitle,
  DrawerItemContent
} from 'dpl/common/components/Drawer';

export default function SelectPaymentTypeLearnMoreDrawer({
  icon,
  title,
  subtitle,
  content,
  helpTitle,
  helpIssues,
  learnMoreLink
}) {
  return (
    <div className="SelectPaymentTypeLearnMoreDrawer f2">
      <Drawer>
        <div className="ba br3 b--lightest-gray">
          <DrawerItem itemKey={helpTitle} className="">
            <div className="pv4 ph6 bb b--lightest-gray">
              <div className="flex align-items-center mb2">
                <Icon
                  name={icon}
                  height="28px"
                  width="28px"
                  className="ba br-100 bg-stroll-light b--transparent ph1 pv1"
                />
                <h5 className="f3 ml2 lh-normal">{title}</h5>
              </div>
              <p className="fw-medium mb2">{subtitle}</p>
              <p className="pb2">{content}</p>
            </div>
            <div className="ph6">
              <DrawerItemTitle className="pv2">
                <p className="fw-medium">{helpTitle}</p>
              </DrawerItemTitle>
              <DrawerItemContent>
                <ul className="SelectPaymentTypeLearnMoreDrawer ml3 ph2">
                  {helpIssues.map(issue => (
                    <li className="list--disc-outside mb2" key={issue}>
                      {issue}
                    </li>
                  ))}
                </ul>
                <a
                  className="f2 stone-700 fw-medium"
                  href={learnMoreLink}
                  target="_blank"
                  rel="noreferrer"
                >
                  Learn more
                </a>
              </DrawerItemContent>
            </div>
          </DrawerItem>
        </div>
      </Drawer>
    </div>
  );
}

SelectPaymentTypeLearnMoreDrawer.propTypes = {
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  helpIssues: PropTypes.arrayOf(PropTypes.string).isRequired,
  helpTitle: PropTypes.string.isRequired,
  learnMoreLink: PropTypes.string.isRequired
};
